"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBillingAdminSelector = exports.authSelector = void 0;

var _Scopes = _interopRequireDefault(require("pricing-pages-unified-ui/constants/Scopes"));

var _reselect = require("reselect");

var authSelector = function authSelector(state) {
  return state.auth;
}; // Permissions to make changes/buy products that require purchases


exports.authSelector = authSelector;
var isBillingAdminSelector = (0, _reselect.createSelector)(authSelector, function (auth) {
  // This check is only for if we dual-deploy and have non-auth
  if (!auth || !auth.user || !auth.user.scopes) {
    return false;
  }

  var scopeList = auth.user.scopes;
  var hasHubBillingWrite = scopeList.some(function (scope) {
    return scope === _Scopes.default.BILLING_WRITE;
  });
  return hasHubBillingWrite;
});
exports.isBillingAdminSelector = isBillingAdminSelector;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/AuthAdminSelectors.js
// module id = 299
// module chunks = 5 6 7